import { useState, useEffect } from "react";

export function useOnlineStatus() {
    const [isOnline, setIsOnline] = useState<boolean>(true);

    useEffect(() => {
        function setOnline() { setIsOnline(true); }
        function setOffline() { setIsOnline(false); }

        window.addEventListener("online", setOnline);
        window.addEventListener("offline", setOffline);

        return () => {
            window.removeEventListener("online", setOnline);
            window.removeEventListener("offline", setOffline);
        }
    }, []);

    return isOnline;
}